import get from 'lodash/get'

export const getLocale = (channelData) => {

  const features = get(channelData, 'features')
  if (!features) {

    return false

  }

  const enabledFeature = channelData.features.find(({ name, enabled }) => name === 'locale' && enabled === true)
  if (!enabledFeature) {

    return false

  }

  return enabledFeature.value

}
